import CurrencyComponent from 'formiojs/components/currency/Currency';
import editForm from './extended-currency.form';
import { CustomComponentType } from '../../../../enums';
import { Utils as FormioUtils } from 'formiojs';

import {
	getKey,
	attachWithChangeEvent,
	checkConditionalityAcrossForms,
	handleSetDefaultValue,
	shouldInputFieldUseOriginalConditionality,
	unset
} from '../extended-field-helper';
import { shouldUpdateOriginalLabel, updateOriginalLabel } from '../../../../utils/data-field-metadata/data-field-metadata-utils';
import _ from 'lodash';
import { FormioConditionalityUtils } from '../../../../utils/formio-conditionality-utils';

export default class ExtendedCurrency extends CurrencyComponent {
	static schema(...extend: any) {
		return CurrencyComponent.schema(
			{
				type: CustomComponentType.extendedCurrency,
				forceRequired: false,
				dataFieldId: null
			},
			...extend
		);
	}

	static get builderInfo() {
		return {
			title: 'Currency',
			group: '',
			weight: 10,
			schema: ExtendedCurrency.schema()
		};
	}

	static editForm = editForm;

	// @ts-ignore
	set visible(value: boolean) {
		var isChanged = this.visible !== value;

		super.visible = value;

		if (isChanged) {
			this.setValue(this.dataValue);
		}
	}

	get visible() {
		return super.visible;
	}

	// @ts-ignore
	get key(): string {
		return getKey(this, super.key);
	}

	get prefix() {
		if (!this.options.readOnly) {
			return this.component.prefix;
		}

		const decimalLimit = _.get(this.component, 'decimalLimit', 2);
		const affixes = FormioUtils.getCurrencyAffixes({
			currency: this.component.currency,
			decimalLimit: decimalLimit,
			decimalSeparator: this.decimalSeparator,
			lang: this.options.language
		});

		return this.options.prefix || affixes.prefix;
	}

	async attach(element: HTMLElement) {
		const superAttach = super.attach(element);

		attachWithChangeEvent(this);

		if (shouldUpdateOriginalLabel(this)) {
			await updateOriginalLabel(this);
		}

		return superAttach;
	}

	conditionallyVisible(data: any): boolean {
		if (shouldInputFieldUseOriginalConditionality(this)) {
			return super.conditionallyVisible(data);
		}

		return checkConditionalityAcrossForms(this);
	}

	checkCondition(row: any, data: any) {
		return FormioConditionalityUtils.checkCondition(
			this.component,
			row || this.data,
			data || this.rootValue,
			this.root ? (this.root as any)._form : {},
			this
		);
	}

	/**
	 * Set the value at a specific index.
	 *
	 * @param index
	 * @param value
	 */
	setValueAt(index: number, value: number, flags: any = {}) {
		const result = super.setValueAt(index, value, flags);
		handleSetDefaultValue(this, index, value, flags);

		return result;
	}

	formatValue(input: any) {
		var formioFormattedValue = super.formatValue(input);

		if (this.options.readOnly && formioFormattedValue != null && formioFormattedValue !== '') {
			return formioFormattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, this.delimiter);
		}

		return formioFormattedValue;
	}

	unset(): void {
		unset(this);
	}
}
